import { useTranslation } from "react-i18next";
import { Button, Navbar, Nav, Form, InputGroup } from "react-bootstrap";

import Logo from "../../assets/img/logo.png";
import bkLogo from "../../assets/img/birkenstock_logo.png";
import hdLogo from "../../assets/img/hey_dude.png";
import tbLogo from "../../assets/img/ted_baker.png";
import dcLogo from "../../assets/img/digicape_logo_black.png";
import htLogo from "../../assets/img/hi-tec.svg"; 
import crLogo from "../../assets/img/crocs_logo_new.png"
import okLogo from "../../assets/img/oakley_logo.png"
import vaLogo from "../../assets/img/va-logo.png";
import uaLogo from "../../assets/img/ua-logo.png";
import sumpLogo from "../../assets/img/sump_logo.png";


import useSidebar from "../../hooks/useSidebar";
import { Logout } from "../auth/Logout";
import { useAuth, UserDetail} from "../../contexts/AuthContext";
import { useEffect } from "react";

// import NavbarDropdown from "./NavbarDropdown";
// import NavbarDropdownItem from "./NavbarDropdownItem";
// import NavbarLanguages from "./NavbarLanguages";
// import NavbarThemeToggle from "./NavbarThemeToggle";
// import NavbarUser from "./NavbarUser";

const NavbarComponent = () => {
	
	const { t } = useTranslation();
	const { isOpen, setIsOpen } = useSidebar();
	const {userDetail , fetchData}  = useAuth();

	let customerLogo = Logo;


	if(process.env.REACT_APP_COMPANY === "ares-bk") {
		customerLogo = bkLogo;
	}

	if(process.env.REACT_APP_COMPANY === "ares-hd") {
		customerLogo = hdLogo;
	}

	if(process.env.REACT_APP_COMPANY === "ares-tb") {
		customerLogo = tbLogo;
	}

	if(process.env.REACT_APP_COMPANY === "digicape" || process.env.REACT_APP_COMPANY === "stockanywhere-digicape") {
		customerLogo = dcLogo;
	}

	if(process.env.REACT_APP_COMPANY === "hi-tec" || process.env.REACT_APP_COMPANY === "stockanywhere-hi-tec") {
		customerLogo = htLogo;
	}

	if(process.env.REACT_APP_COMPANY === "ares-cr") {
		customerLogo = crLogo;
	}

	if(process.env.REACT_APP_COMPANY === "ares-ok") {
		customerLogo = okLogo;
	}

	if(process.env.REACT_APP_COMPANY === "ares-va") {
		customerLogo = vaLogo;
	}

	if(process.env.REACT_APP_COMPANY === "ares-ua") {
		customerLogo = uaLogo;
	}

	if(process.env.REACT_APP_COMPANY === "stockanywhere-sump") {
		customerLogo = sumpLogo;
	}

	useEffect(() => {
		// console.log("UserDetails:");
		// console.log(userDetail);
	}, [userDetail]);

	useEffect(() => {
		const loggedInUrl: string = process.env.REACT_APP_LOGGED_IN_URL as string;
        
		fetchData(loggedInUrl, {method:"GET"}, (result: any) => {
		});
	}, [])


	return (
		<Navbar variant="light" expand className="navbar-bg">
			<span className="sidebar-toggle d-flex" onClick={() => setIsOpen(!isOpen)}>
				<i className="hamburger align-self-center" />
			</span>
			{process.env.REACT_APP_COMPANY === "ares-hd" ? (
				<>
					<span></span>
					<a href="/"><img src={customerLogo} style={{ width: '50px' }} /></a>
				</>
				) : process.env.REACT_APP_COMPANY === "ares-cr" ? (
				<>
					<span></span>
					<a href="/"><img src={customerLogo} style={{ width: '120px' }} /></a>
				</>
				) : process.env.REACT_APP_COMPANY === "ares-ok" ? (
				<>
					<span></span>
					<a href="/"><img src={customerLogo} style={{ width: '90px' }} /></a>
				</>
				) : process.env.REACT_APP_COMPANY === "ares-va" ? (
				<>
					<span></span>
					<a href="/"><img src={customerLogo} style={{ width: '90px' }} /></a>
				</>
				) : process.env.REACT_APP_COMPANY === "ares-ua" ? (
				<>
					<span></span>
					<a href="/"><img src={customerLogo} style={{ width: '60px' }} /></a>
				</>

				) : process.env.REACT_APP_COMPANY === "ares-tb" ? (
				<>
					<span></span>
					<a href="/"><img src={customerLogo} style={{ width: '99px' }} /></a>
				</>
				) : process.env.REACT_APP_COMPANY === "stockanywhere-sump" ? (
				<>
					<span></span>
					<a href="/"><img src={customerLogo} style={{ width: '80px' }} /></a>
				</>
				 ) : (
				 <>
					<span></span>
					<a href="/"><img src={customerLogo} style={{ width: '120px' }} /></a>
				 </>
				)}
			
			<div className="d-flex justify-content-end w-100 gap-3 align-items-center ps-3" >
				<div className="d-flex justify-content-left w-100 gap-3 align-items-center" >
					<span>{`Welcome ${userDetail?.firstName ? userDetail.firstName : ''} ${userDetail?.lastName ? userDetail.lastName : ''} [${userDetail?.userName}]`}</span>	
				</div>
				<Logout />		
				<a href="/">
					<img src={Logo} style={{width: '200px', marginBottom: "-7px"}} />
				</a>
			</div>
		</Navbar>
	);
};

export default NavbarComponent;


